import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14 11h-4v4H9v-4H5v-1h4V6h1v4h4v1zM9.5 3c4.136 0 7.5 3.364 7.5 7.5S13.636 18 9.5 18 2 14.636 2 10.5 5.364 3 9.5 3zm0-1C4.825 2 1 5.825 1 10.5S4.825 19 9.5 19s8.5-3.825 8.5-8.5S14.175 2 9.5 2z',
  ],
  height: 20,
  width: 20,
});
